import { Component, Input, Output } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { hasValidator } from '../_helpers/functions';

type HTMLInputTypeAttribute =
    | 'button'
    | 'checkbox'
    | 'color'
    | 'date'
    | 'datetime-local'
    | 'email'
    | 'file'
    | 'hidden'
    | 'image'
    | 'month'
    | 'number'
    | 'password'
    | 'radio'
    | 'range'
    | 'reset'
    | 'search'
    | 'submit'
    | 'tel'
    | 'text'
    | 'time'
    | 'url'
    | 'week';

@Component({
    selector: 'sume-input',
    templateUrl: './field.component.html',
    styleUrls: ['./field.component.scss'],
})
export class FieldComponent {
    @Input() customFeedbackMessage: string;
    @Input() dropSpecialCharacters = true;
    @Input() type: HTMLInputTypeAttribute;
    @Input() currency: boolean;
    @Input() label: string;
    @Input() displayLabel = true;
    @Input() controlName: string;
    @Input() formGroup: FormGroup;
    @Input() messages: any;
    @Input() changeText = false;
    @Input() range = [0];
    @Input() step: number;
    @Input() mask;
    @Input() placeholder = '';
    @Input() helpMessage: string;
    @Output() current: any;
    get formControl(): AbstractControl {
        return this.formGroup.get(this.controlName);
    }

    get isRequired(): boolean {
        return hasValidator(this.formControl, 'required');
    }

    get isInvalid(): boolean {
        return (
            this.formControl?.invalid &&
            (this.formControl.dirty ||
                this.formControl.touched ||
                this.changeText)
        );
    }
}
